module.exports = __webpack_public_path__ + "img/warning.6fa2702.png";